import { useContext } from 'react';

import { ListContext } from '@contexts/ListContext';

const useContactGatewayConfigurations = () => {
    const { cachedList } = useContext(ListContext);
    return cachedList.contactGatewayConfigurations.items;
};

export default useContactGatewayConfigurations;
